import { Injectable } from '@angular/core';
import moment from 'moment';
import { GlobalConstants } from './../global-constants';
import tinycolor from 'tinycolor2';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    constructor(private globalConstants: GlobalConstants) { }
    getFontColor(color: any): string {
        if (tinycolor(color).getLuminance() < 0.5) {
            if (tinycolor.isReadable(color, '#FFFFFF')) {
                return '#FFFFFF';
            } else {
                return '#000000';
            }
        } else {
            if (tinycolor.isReadable(color, '#000000')) {
                return '#000000';
            } else {
                return '#FFFFFF';
            }
        }
    }
    
    getDate(date: Date, format: string) {
        const dateFormat = this.globalConstants.format.date;
        return moment.parseZone(date).format(dateFormat);

    }
    getLightenColor(color: string, value: number): string {
       // console.log(value + color);
        return tinycolor(color).lighten(value).toString();
    }

    compareObjects(originalObject: any, newObject: any): Boolean {
        const oldModel: string = JSON.stringify(originalObject);
        const newModel: string = JSON.stringify(newObject);
        if (oldModel !== newModel) {
            return false;
        }
        return true;
    }

    videoStatusAvailable(videoStatus: string): boolean {
        const unavailableStatuses: string[] = [
            '',
            'NA',
            'private',
            'delete',
            'rejected',
        ]
        return !unavailableStatuses.includes(videoStatus)
    }

}
